module.exports = __webpack_public_path__ + "img/ldyy.e51db566.jpg";